import styled from 'styled-components'

export const ModalMainDiv = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100vw;
`;
export const ModalDiv = styled.div`
  max-height: 90vh;
  position: fixed;
  z-index: 501;
  background-color: white;
  border-radius: 12px;
  box-shadow: 1px 1px 1px black;
  padding: 0px;
  top: 5%;
  box-sizing: border-box;
  transition: all 0.3s ease-out;
  text-align: left;
  font-family: sans-serif;
  overflow-y: scroll;
`;
export const ModalWrapDiv = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 500;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
export const CloseModalDiv = styled.div`
  height: 24px;
  width: 24px;
  background-color: #bfbfbf;
  border-radius: 12px;
  color: #ffffff;
  font-size: 18px;
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  text-align: center;
  &:hover {
    background-color: #1B49EA;
  }
`;
export const ModalHeadingDiv = styled.div`
  font-family: sans-serif;
  font-weight: bold;
  font-size: 18px;
  color: #000000;
  display: block;
  margin-bottom: 16px;
  padding: 30px 30px 0px 30px;
`;
